import { ServiceLine, Work, WorkLocation } from "../../types/works";
import { findServiceType } from "../../constants/worksConstants";

/**
 * Display helpers for the works UI. Names are read from the denormalized fields
 * the backend (worksController.formatWork) puts on each work / service line —
 * no client-side catalog lookup needed for display.
 */

export const getCustomerName = (work: Pick<Work, "customerName">) =>
  work.customerName || "—";

export const getDriverName = (work: Pick<Work, "driverName">) =>
  work.driverName || "—";

export const getVehicleLabel = (work: Pick<Work, "vehicleLabel">) =>
  work.vehicleLabel || "—";

export const getObjectName = (location?: WorkLocation) =>
  location?.name || location?.address || "—";

export const getServiceName = (line: Pick<ServiceLine, "name">) =>
  line.name || "—";

export const getServiceIcon = (line: Pick<ServiceLine, "serviceTypeId">) =>
  findServiceType(line.serviceTypeId)?.icon ?? "•";

export const formatDateTime = (iso?: string) => {
  if (!iso) return "—";
  const date = new Date(iso);
  return date.toLocaleString(undefined, {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatDate = (iso?: string) => {
  if (!iso) return "—";
  const date = new Date(iso);
  return date.toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" });
};

/** "9.5" -> "9h 30m" */
export const formatHours = (hours?: number) => {
  if (hours === undefined || hours === null) return "—";
  const h = Math.floor(hours);
  const m = Math.round((hours - h) * 60);
  if (m === 0) return `${h}h`;
  return `${h}h ${m}m`;
};

export const routeLabel = (primaryObject?: WorkLocation, secondaryObject?: WorkLocation) => {
  const from = getObjectName(secondaryObject);
  const to = getObjectName(primaryObject);
  if (secondaryObject && primaryObject) return `${from} → ${to}`;
  return to;
};
